import { NumericRangeType, NumericField } from "@decisions/server/DecisionsFramework/Design/Page/Filters";
import { IActionLinkItems } from "components/ActionLinks/ActionLinkModels";
import { ActionLinks } from "components/ActionLinks/ActionLinks";
import { PickButton } from "components/buttons/PickButton/PickButton";
import { getLabelForNumericMatchType, getNumericFieldOptions } from "components/inputs/data-filters/helpers/NumericRangeHelpers";
import { NumericFieldFilter } from "components/inputs/data-filters/NumericFieldFilter";
import { Callout } from "components/layout/Callout";
import React, { MutableRefObject, useRef, useState } from "react";
import { IEditorProps } from '../Editor';
import { EditorLabel } from "../EditorLabel";
import { useScopeHandlers } from "./hooks/useScopeHandlers";

export interface INumericFieldFilterEditorProps extends IEditorProps {}

export function NumericFieldFilterEditor({ child, path, onChange, hideInputLabel }: INumericFieldFilterEditorProps) {
  const [value, setValue] = useState(child.Value.OutputValue as NumericField);
  const linkRef: MutableRefObject<HTMLButtonElement | null> = useRef(null);
  const [changingMatchType, setChangingMatchType] = useState(false);
  const toggleMatchTypeOpen = () => {
    setChangingMatchType(!changingMatchType);
  };
  const [matchType, setMatchType] = useState<NumericRangeType>(value.MatchType);

  const onMatchChange = (MatchType: NumericRangeType) => {
    setMatchType(MatchType);
    onValueChange({ ...value, MatchType });
    setChangingMatchType(false);
  };

  const onValueChange = (newValue: NumericField) => {
    onChange(newValue, path);
    setValue(newValue);
  };

  const matchOptions: IActionLinkItems = {
    current: getNumericFieldOptions(),
  };

  const currentMatchTypeName = getLabelForNumericMatchType(matchType);

  const { personalization } = useScopeHandlers({ value, path, setValue, onChange });

    return (
        <EditorLabel
          editor={child}
          path={path}
          hideInputLabel={hideInputLabel}
          actions={<PickButton onClick={toggleMatchTypeOpen} text={currentMatchTypeName} buttonRef={linkRef} />}
          doNotWrap={true}
        >
          <NumericFieldFilter value={value} onChange={onValueChange} personalization={personalization} />
          <Callout
            isOpen={changingMatchType}
            onClose={toggleMatchTypeOpen}
            sourceRef={linkRef}
            placement="bottom"
            showArrow={true}
            flipBehavior="counterclockwise"
            open={changingMatchType}
          >
            <ActionLinks values={matchOptions} callback={onMatchChange} />
          </Callout>
        </EditorLabel>
      );
}